var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showImage)?_c('span',[_c('img',{staticClass:"country-display",attrs:{"src":_vm.imagePath},on:{"error":function($event){return _vm.imageError()}}})]):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.countryDisplay)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }